import PropTypes from 'prop-types';
import numeral from 'numeral';
import StringSearchDisplay from 'components/formatting/string-search-display';
import Pagination from 'components/controls/pagination';
import { LinkButton } from '@evertrue/et-components';
import FilterSource from 'apps/filters/sources/filter-source';
import UrlSource from 'apps/layout/sources/url-source';
import CoreSearchSource from 'apps/core-search/sources/core-search-source';
import CoreSearchConfig from 'apps/core-search/utils/core-search-config';
import EverTrue from 'app';

const GlobalSearchResultsModule = ({
  label = '',
  total = 0,
  query = '',
  queryType = 'all',
  page = 1,
  offset = 0,
  limit = 5,
  setOffset = () => {},
  setPage = () => {},
  children,
}) => {
  const handleViewAll = () => {
    const type = label === 'Interactions' ? 'interactions' : 'contacts';
    const pathname = window.location.pathname;
    UrlSource.updateSegment();
    FilterSource.updateOperator('and');
    FilterSource.set([
      {
        filter_id: '0.015',
        filter_row_id: 0,
        value: { value: query, type, queryType },
      },
    ]);

    CoreSearchSource.query(type);
    const route = CoreSearchConfig[type]?.route;
    const nav = !pathname.match(new RegExp(`^${route}(\\?)?[^\\/]*$`));
    EverTrue.UrlManager.navigate(route, nav, false);
  };

  const onPageChange = (page) => {
    setOffset(offset + (page - 1) * limit);
    setPage(page);
  };

  const showViewAll = (queryType === 'all' || queryType === 'name') && total > 1;
  const shouldShowPagination = total > limit && label !== 'Interactions';

  return (
    <div className="global-autocomplete-results--module">
      <div className="global-autocomplete-results--module-header">
        <div className="global-autocomplete-results--module-label">{label}</div>
        {shouldShowPagination && (
          <div className="global-autocomplete-results--module-pagination">
            <Pagination
              className="global-autocomplete-results--module-pagination"
              page={page}
              total={Math.ceil(total / limit)}
              onChange={onPageChange}
            />
          </div>
        )}
        <div className="global-autocomplete-results--meta">
          {'Showing '}
          <strong>{`${offset + 1} - ${Math.min(offset + limit, total)}`}</strong>
          {' of '}
          <strong>{numeral(total || 0).format('0,0')}</strong>
          {total === 1 ? ' result for ' : ' results for '}
          <StringSearchDisplay string={query} />
          {showViewAll && (
            <LinkButton className="global-autocomplete-results--module-link-button" onClick={handleViewAll}>
              View all
            </LinkButton>
          )}
        </div>
      </div>
      <div className="global-autocomplete-results--module-body">{children}</div>
    </div>
  );
};

export default GlobalSearchResultsModule;

GlobalSearchResultsModule.propTypes = {
  label: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  query: PropTypes.string.isRequired,
  page: PropTypes.number,
  offset: PropTypes.number,
  limit: PropTypes.number,
  children: PropTypes.node,
  queryType: PropTypes.string.isRequired,
  setOffset: PropTypes.func,
  setPage: PropTypes.func,
};
